import { Component, OnInit } from '@angular/core';
import { ApiService, User } from 'angular-lib';

@Component({
    selector: 'ez-my-profile',
    template: require('./my-profile.component.html'),
    styles: [require('./my-profile.component.less')]
})
export class MyProfileComponent implements OnInit {
    public user: User;
    public pictureUrl: string;
    public albumUrl: string;
    public noPublicPicturesUploaded: boolean = true;
    public onlyPrivatePictures: boolean = true;

    constructor(
        private apiService: ApiService
    ) {
    }

    public ngOnInit () {
        this.apiService.user().subscribe(user => {
                this.user = user;
                this.pictureUrl = user.genderId === 2 ? '/img/thumb-man.png' : '/img/thumb-woman.png';

                if (this.user.pictures.length > 0) {
                    for (let pic of this.user.pictures) {
                        if (pic.access === 'default') {
                            this.pictureUrl = user.picturesUrl[pic.id];
                        }

                        if (
                            (pic.access === 'all' || pic.access === 'default')
                            && (pic.status === 'pending' || pic.status === 'approved')
                        ) {
                            this.noPublicPicturesUploaded = false;
                        }

                        if (pic.access !== 'private') {
                            this.onlyPrivatePictures = false;
                        }
                    }
                } else {
                    // if user doesn't have any image, set onlyprivate to false
                    this.onlyPrivatePictures = false;
                }
            },
            err => console.error('failed to get me ' + err.message),
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/profile/my-profile/my-profile.component.ts